import React, {Component} from 'react';
import {Card} from "react-bootstrap";
import {Content} from "../../../../model/content";
import "./home_page_mobile_card.scss";
import LuissButton from "../../../../common_components/luiss_button/luiss_button";
import {Translation} from "react-i18next";
import {TFunction} from "i18next";

class HomePageMobileCard extends Component<Content, any> {

    constructor(props: Content) {
        super(props);
        this.state = {
            touched: false
        };
    }

    render() {
        let cardBackground = {
            backgroundColor: "black",
            backgroundImage:
                'linear-gradient(rgba(0, 0, 0, ' + 0.3 + '),rgba(0, 0, 0, ' + 0.3 + ')), url(' + this.props.image + ')'
        };

        return (
            <Card className={"home-page-mobile-card " + (this.state.touched ? "touched" : "")}
                  style={cardBackground} onTouchStart={() => this.setState({touched: true})}
                  onTouchEnd={() => this.setState({touched: false})}>
                <Card.Body>
                    {this.props.title ? <Card.Title className="not-selectable">{this.props.title}</Card.Title> : null}
                </Card.Body>
                <Card.Footer>
                    {this.props.image ? <img src={this.props.image} className="blurred-overlay" alt={this.props.title}/> : null}
                    {this.props.subtitle ? <Card.Text className="text not-selectable">{this.props.subtitle}</Card.Text> : null}
                    { this.props.url &&
                        <Translation>
                            {(t: TFunction) =>
                                <LuissButton url={this.props.url}>{t("HOME PAGE mobile card button")}</LuissButton>
                            }
                        </Translation>
                    }
                </Card.Footer>
            </Card>
        );
    }
}

export default HomePageMobileCard;
